module.exports = __webpack_public_path__ + "img/liufeng.43033e32.png";